import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49f46fce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaneListBuildingParts CustomScrollbar" }
const _hoisted_2 = { class: "PaneIntro" }
const _hoisted_3 = { class: "List" }
const _hoisted_4 = { class: "ListLabels PaneLine Disabled" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = { class: "Label" }
const _hoisted_7 = { class: "Label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "PaneEmptyText"
}
const _hoisted_10 = { class: "ListContent" }
const _hoisted_11 = {
  key: 0,
  class: "Note"
}
const _hoisted_12 = {
  key: 0,
  class: "Heading2 SubHeading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaneTitle = _resolveComponent("PaneTitle")!
  const _component_PageVideoGuide = _resolveComponent("PageVideoGuide")!
  const _component_PaneLineBuildingPart = _resolveComponent("PaneLineBuildingPart")!
  const _component_PaneLink = _resolveComponent("PaneLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaneTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.mixWB('REGISTERED_TYPES')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('REGISTERED_MATERIALS_PAGE_INTRO_TEXT_1')), 1),
      _createVNode(_component_PageVideoGuide, { guide: "materials" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.mixWB('BUILDING_PART')), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.mixWB('WEIGHT')), 1),
        _hoisted_8
      ]),
      (!_ctx.buildingPartsWithOnlineTypes.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.mixWB('NO_TYPES_REGISTERED_YET')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingPartsWithOnlineTypes, (buildingPart) => {
          return (_openBlock(), _createBlock(_component_PaneLink, {
            key: buildingPart.hashID,
            class: "PaneLine",
            "pane-id": buildingPart.hashID
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PaneLineBuildingPart, { buildingPart: buildingPart }, null, 8, ["buildingPart"])
            ]),
            _: 2
          }, 1032, ["pane-id"]))
        }), 128)),
        (_ctx.buildingPartsWithOnlineTypes.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "* " + _toDisplayString(_ctx.mixWB('MISSING_CALCULATIONS')), 1))
          : _createCommentVNode("", true),
        (_ctx.buildingPartsWithOnlineTypes.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.buildingPartsWithoutOnlineTypes.length)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_12, _toDisplayString(_ctx.mixWB('UNUSED_BUILDING_PARTS')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildingPartsWithoutOnlineTypes, (buildingPart) => {
                return (_openBlock(), _createBlock(_component_PaneLink, {
                  key: buildingPart.hashID,
                  class: "PaneLine"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PaneLineBuildingPart, { buildingPart: buildingPart }, null, 8, ["buildingPart"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}